<template lang="html">
  <nav>
    <ul>
      <li><router-link :to="{ name: 'BillsPage', params: {} }">Bills</router-link></li>
      <li><router-link :to="{ name: 'TransactionsPage', params: {} }">Activity Feed</router-link></li>
<!--      <li><router-link :to="{ name: 'BankSubmissionsPage', params: {} }">Bank Submissions</router-link></li>-->
      <li><router-link :to="{ name: 'ZreportsPage', params: {} }">Z Reports</router-link></li>
      <li><router-link :to="{ name: 'SettlementPage', params: {} }">Settlements</router-link></li>
<!--      <li><router-link :to="{ name: 'ReportsPage', params: {} }">Reports</router-link></li>-->
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SalesSubheader"
}
</script>

<style lang="css" scoped>

nav ul{
  list-style: none;
  padding: 0;
  border-bottom: 3px solid rgb(227, 70, 150);
}

nav ul li{
  display: inline-block;
  margin-right: 30px;
  border: 1px solid rgb(227, 70, 150);
  font-size: 14px;
  border-radius: 3px;
}

nav ul li a{
  background-color: transparent;
  width: 173px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: rgb(227, 70, 150);
  font-weight: bold;
}

.router-link-active{
  background-color: #D1CAE4;
}

</style>
